// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--qoUor","menuList":"menuList--b5wKi"};